angular.module('navigationHeaderModule').directive('navigationHeader', function () {
  return {
    restrict: 'E',
    templateUrl: '/resources/navigation-header/partials/navigation-header.html',
    controller: [
      'dblAnalyticsProvider',
      '$cookies',
      'configuration',
      'navigationTabsService',
      '$rootScope',
      '$scope',
      'settingsApi',
      '$state',
      '$timeout',
      '$window',
      'authentication',
      'dblModalService',
      'edxFeatureFlagService',
      'edxReportItemService',
      'navigation',
      'assignMode',
      'classroomApi',
      'edxPendingChangesModalService',
      function (
        $analytics,
        $cookies,
        $configuration,
        $navigationTabs,
        $rootScope,
        $scope,
        $settingsApi,
        $state,
        $timeout,
        $window,
        authentication,
        dblModalService,
        edxFeatureFlagService,
        edxReportItemService,
        navigation,
        assignMode,
        classroomApi,
        edxPendingChangesModalService
      ) {
        var STATUS_CHECK_TIMEOUT = 1000;
        var customerIsAdmin = authentication.getCustomer().isAdmin();
        $scope.isApiKeyEnabled = $configuration.isFeatureEnabled('api_key');

        $scope.authenticationService = authentication;
        $scope.options = [
          {
            id: 0,
            title: 'Log Out',
            notification: 'logOutPressed'
          }
        ];

        $scope.useBts2020Nav = authentication.useBts2020Nav();

        var customerSubject = authentication.getCustomerSubject();
        var customerRole;
        var customerId;

        customerSubject.subscribe(function (customer) {
          customerRole = customer.role;
          customerId = customer.id;
          $scope.customerCanEdit = customer.getSettingsPermissions().canEdit;
          $scope.customerName = customer.name;

          /**
           * classroom ids are only provided for 'teacher' level, admins with classes need
           * to query the classroom end point
           * suggest future spike on Product to provide classroom ids for admins as well.
           * Didn't do fix this time because full regression of product would be needed, and we are t minus 2 weeks from bts2020
           * https://www.flowdock.com/app/dreambox/tonic-ai-poc/threads/KOKqhkQ0TN7NURBntqiGlbxAhGz
           */
          if (customer.isTeacher()) {
            $scope.hasClassroomAccess = customer.hasClassrooms();
          } else if(customerRole === 'guardian'){
            $scope.hasClassroomAccess = false;
          } else {
            classroomApi.getClassroomsForTeacherInDistrict(customer.id, customer.district_id, function (classroomList) {
              $scope.hasClassroomAccess = classroomList && classroomList.length > 0;
            });
          }
        });

        var getEnabled = function () {
          if ($cookies.get('helpEnabled')) {
            return $cookies.get('helpEnabled') === 'true';
          } else {
            $cookies.get('helpEnabled');
            $cookies.put('helpEnabled', 'false');
            return false;
          }
        };
        $rootScope.helpEnabled = getEnabled();

        var validateNavigatingAway = function (url) {
          var saveButton = document.querySelector('.dbl-save-button');
          if (!saveButton) {
            navigation.go(url);
          } else {
            var dirtyTab = !saveButton.firstChild.disabled;
            if (dirtyTab) {
              edxPendingChangesModalService.setIsPending(true);
              navigation.tryNavigate().then(function () {
                navigation.go(url);
              });
            } else {
              edxPendingChangesModalService.setIsPending(false);
              navigation.go(url);
            }
          }
        };

        ////////////////////////////////////////////////////////
        // Deprecated Settings form                           //
        // (the new settings area is referred to as "Manage") //
        ////////////////////////////////////////////////////////
        var getMessage = function (type) {
          var msg = '';

          switch (type) {
            case 'minlength':
              msg = 'too short';
              break;
            case 'required':
              msg = 'required';
              break;
            case 'maxlength':
              msg = 'too long';
              break;
            default:
              msg = 'error';
          }

          return msg;
        };

        var itemSubscription = edxReportItemService.getItemObservable().subscribe(function (item) {
          $scope.item = item;
        });

        $scope.getCustomerId = function () {
          return 'c' + authentication.getCustomer().id;
        };

        var pdOnBoardingEnabled = edxFeatureFlagService.isPdOnBoardingEnabled();

        // This is here to support 'new content' badges. This work is not currently done, so this always returns
        // false for now.
        $scope.hasNewResources = function () {
          return false;
        };

        $scope.edxResourcesClick = function () {
          if ($state.current.name !== 'dbl-resources') {
            validateNavigatingAway('dbl-resources');
          }
        };

        $scope.flexpdClick = function () {
          if ($state.current.name !== 'myflexpd') {
            window.open('https://university-getstarted.dreambox.com/');
          }
        };

        $scope.isCurrentState = function (name) {
          // see routes.js for state names
          if ($state.current.name === name) {
            return true;
          } else if ($state.current.parent === name) {
            // this handles the 'report' case
            return true;
          }

          return false;
        };

        $scope.manageClick = function () {
          if ($state.current.name !== 'manage') {
            if (customerIsAdmin) {
              // settings context is used on upgraded Angular Settings page to preserve tab and dropdown selections
              // across page refreshes. Navigation away from that page should clear this context to give the
              // user a fresh view. Rather than clearing it on all navigation events, clearing it only when the
              // user navigates to the Settings page has the same effect
              $window.localStorage.setItem('settingsContext', null);
              navigation.go('settings');
            } else {
              validateNavigatingAway('teacher-settings');
              return false;
            }
          }
        };

        $scope.reportClick = function () {
          navigation.goHome();
        };

        $scope.apiKeyClick = function () {
          if ($scope.isApiKeyEnabled) {
            validateNavigatingAway('api-key');
          } else {
            validateNavigatingAway('home');
          }
        };

        $scope.newReportsClick = function () {
          // Don't navigate to reports page if user is an unrostered teacher. Instead, navigate to "missing roster" error page
          if (customerRole === 'teacher' && !$scope.hasClassroomAccess) {
            validateNavigatingAway('missingroster');
          } else {
            validateNavigatingAway('reports');
          }
        };

        $scope.homeClick = function () {
          validateNavigatingAway('home');
        };

        $scope.onDropdownHeaderOptionClick = function (notification) {
          // can attach arguments after notification to pass on with it
          $scope.$emit(notification);
        };
        $rootScope.onModalOpenClick = function (notification) {
          // can attach arguments after notification to pass on with it
          $scope.$emit(notification);
        };

        $scope.$on('$destroy', function () {
          itemSubscription.dispose();
        });
      }
    ]
  };
});
